import { useMemo } from "react";
import { cachedLoadSkiaWeb } from "../../../helpers/prefetchSkia/prefetchSkia.web";

const useLoadSkiaWebPromise = () => {
	return useMemo(() => cachedLoadSkiaWeb(), []);
};
export default useLoadSkiaWebPromise;
